<script setup lang="ts">
import HomeView from '@/views/HomeView.vue'
import { onMounted, ref } from 'vue'
import { useAuthStore } from './stores/auth.store'
import { useAppShadowRootProvider } from './composables/app-shadow-root/app-shadow-root.composable'
import { MODAL_CONTAINER_ID } from './ts/constants/constants'

const authStore = useAuthStore()
const isAuthenticated = ref(false)

useAppShadowRootProvider()

onMounted(async () => {
  await authStore.authenticate()
  isAuthenticated.value = authStore.isAuthenticated()
})
</script>

<template>
  <HomeView v-if="isAuthenticated" />
  <div :id="MODAL_CONTAINER_ID"></div>
</template>

<style lang="scss">
@import '@ui-lib/index.css';
@import '@/styles/styles.scss';

:host {
  display: block;
}

#linexo-site-connect-modal-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
